import { BMS_API_KEY } from "@/app/utilities/constants";

export const BMS_CONFIG = { 
  scriptSrc: "https://bms-prod.tractorjunction.com/v1.0/banner-loader.js",
  apiBaseUrl: "https://bms-prod-backend.tractorjunction.com/api/v2",
  apiKey: BMS_API_KEY
};

export const BMS_PLACEHOLDER_IDS = {
  homepage_top_banner: "6968a9864477c8d8b51344eb",
  new_cars_top_banner: "69fd983405c9bb29500ae089",
  brand_page_top_banner: "6a0bfdb505c9bb2950134210"
}